import { ClearStorage, SetItemInStorage } from "../../custom_hooks/useStorage";
import _ from "lodash";
import jwt_decode from "jwt-decode";
import store from "../../store/redux-store/root_store";
import { useNavigate } from "react-router-dom";

export class Cookie {
  static host = window.location.hostname;

  static set(name: any, value: any, days: any) {
    var domain, domainParts, date: any, expires;

    if (days) {
      date = new Date();

      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);

      expires = "; expires=" + date.toGMTString();
    } else {
      expires = "";
    }

    if (this.host.split(".").length === 1) {
      document.cookie = name + "=" + value + expires + "; path=/";
    } else {
      domainParts = this.host.split(".");

      domainParts.shift();

      domain = domainParts.join(".");

      document.cookie = name + "=" + value + expires + "; path=/; domain=" + domain;
    }
  }

  static get = () => {
    return document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce((accumulator, [key, value]) => {
        if (key.trim()) return { ...accumulator, [key.trim()]: decodeURIComponent(value) };
        else return "";
      }, {});
  };

  static clear = () => {
    const host = window.location.hostname;

    const domainParts = host.split(".");

    domainParts.shift();

    const domain = domainParts.join(".");

    document.cookie = "accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "roleId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "stateChange=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "userDetials=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "workStatus=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "userEmail=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "refreshToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "MY_APP_STATE=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "agentExt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
    document.cookie = "RememberMe=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;domain=" + domain;
  };
}

export const determineIps = async () => {
  //https://getip.worktual.co.uk/
  const pc = new RTCPeerConnection({ iceServers: [{ urls: "stun:qaaudioturnv4.worktual.co.uk:443" }] });
  await pc.createDataChannel("");
  await pc.createOffer().then((offer) => pc.setLocalDescription(offer));
  pc.onicecandidate = async (ice) => {
    if (!ice || !ice.candidate || !ice.candidate.candidate) {
      pc.close();
      return;
    }
    let split = ice.candidate.candidate.split(" ");

    if (split[7] === "host") {
      logInfo(`Local IP : ${split[4]}`, "");
    } else {
      logInfo(`External IP : ${split[4]}`, "");
      SetItemInStorage("IP", split[4]);
    }
  };
};

export const logInfo = (key: string, value: any) => {
  if (process.env.REACT_APP_ENV === "development") {
  }
};

export const customer: any = [
  "Profile ID",
  "First name",
  "Last name",
  "Position",
  "Customer Type",
  "Category",
  "Organization",
  "Website",
  "Address line",
  "City",
  "Zip_Postal Code",
  "Country",
  "State",
  "Email-Work",
  "Email-Personal",
  "Email-Others",
  "Phone-Work",
  "Phone-Personal",
  "Phone-Others",
  "Whatsapp",
  "Linked In",
  "Twitter",
  "Instagram",
  "Facebook",
  "Notes",
  "Product Interests",
  "Pain points",
  "Preferences",
];

export const system: any = [
  "Customer number",
  "Customer ID",
  "Dialed number",
  "Customer callback number",
  "Stored customer input",
  "Queue name",
  "Queue outbound number",
  "Contact id",
  "Initial Contact id",
  "Previous Contact id",
  "Channel",
  "Initiation method",
  "Language",
  "System Endpoint Type",
  "Queue Outbound Caller ID number",
  "Queue Outbound Caller ID number type",
  "Preferences",
];

export const agent: any = ["Agent User Name", "Agent First Name", "Agent Last Name"];

export const queue: any = [" Custom Queue 4000", "Custom Queue 4001", "Custom Queue 4002"];

export const TIMEZONE: any = [
  {
    id: "Pacific/Niue",
    name: "(GMT-11:00) Niue",
  },
  {
    id: "Pacific/Pago_Pago",
    name: "(GMT-11:00) Pago Pago",
  },
  {
    id: "Pacific/Honolulu",
    name: "(GMT-10:00) Hawaii Time",
  },
  {
    id: "Pacific/Rarotonga",
    name: "(GMT-10:00) Rarotonga",
  },
  {
    id: "Pacific/Tahiti",
    name: "(GMT-10:00) Tahiti",
  },
  {
    id: "Pacific/Marquesas",
    name: "(GMT-09:30) Marquesas",
  },
  {
    id: "America/Anchorage",
    name: "(GMT-09:00) Alaska Time",
  },
  {
    id: "Pacific/Gambier",
    name: "(GMT-09:00) Gambier",
  },
  {
    id: "America/Los_Angeles",
    name: "(GMT-08:00) Pacific Time",
  },
  {
    id: "America/Tijuana",
    name: "(GMT-08:00) Pacific Time - Tijuana",
  },
  {
    id: "America/Vancouver",
    name: "(GMT-08:00) Pacific Time - Vancouver",
  },
  {
    id: "America/Whitehorse",
    name: "(GMT-08:00) Pacific Time - Whitehorse",
  },
  {
    id: "Pacific/Pitcairn",
    name: "(GMT-08:00) Pitcairn",
  },
  {
    id: "America/Dawson_Creek",
    name: "(GMT-07:00) Mountain Time - Dawson Creek",
  },
  {
    id: "America/Denver",
    name: "(GMT-07:00) Mountain Time",
  },
  {
    id: "America/Edmonton",
    name: "(GMT-07:00) Mountain Time - Edmonton",
  },
  {
    id: "America/Hermosillo",
    name: "(GMT-07:00) Mountain Time - Hermosillo",
  },
  {
    id: "America/Mazatlan",
    name: "(GMT-07:00) Mountain Time - Chihuahua, Mazatlan",
  },
  {
    id: "America/Phoenix",
    name: "(GMT-07:00) Mountain Time - Arizona",
  },
  {
    id: "America/Yellowknife",
    name: "(GMT-07:00) Mountain Time - Yellowknife",
  },
  {
    id: "America/Belize",
    name: "(GMT-06:00) Belize",
  },
  {
    id: "America/Chicago",
    name: "(GMT-06:00) Central Time",
  },
  {
    id: "America/Costa_Rica",
    name: "(GMT-06:00) Costa Rica",
  },
  {
    id: "America/El_Salvador",
    name: "(GMT-06:00) El Salvador",
  },
  {
    id: "America/Guatemala",
    name: "(GMT-06:00) Guatemala",
  },
  {
    id: "America/Managua",
    name: "(GMT-06:00) Managua",
  },
  {
    id: "America/Mexico_City",
    name: "(GMT-06:00) Central Time - Mexico City",
  },
  {
    id: "America/Regina",
    name: "(GMT-06:00) Central Time - Regina",
  },
  {
    id: "America/Tegucigalpa",
    name: "(GMT-06:00) Central Time - Tegucigalpa",
  },
  {
    id: "America/Winnipeg",
    name: "(GMT-06:00) Central Time - Winnipeg",
  },
  {
    id: "Pacific/Galapagos",
    name: "(GMT-06:00) Galapagos",
  },
  {
    id: "America/Bogota",
    name: "(GMT-05:00) Bogota",
  },
  {
    id: "America/Cancun",
    name: "(GMT-05:00) America Cancun",
  },
  {
    id: "America/Cayman",
    name: "(GMT-05:00) Cayman",
  },
  {
    id: "America/Guayaquil",
    name: "(GMT-05:00) Guayaquil",
  },
  {
    id: "America/Havana",
    name: "(GMT-05:00) Havana",
  },
  {
    id: "America/Iqaluit",
    name: "(GMT-05:00) Eastern Time - Iqaluit",
  },
  {
    id: "America/Jamaica",
    name: "(GMT-05:00) Jamaica",
  },
  {
    id: "America/Lima",
    name: "(GMT-05:00) Lima",
  },
  {
    id: "America/Nassau",
    name: "(GMT-05:00) Nassau",
  },
  {
    id: "America/New_York",
    name: "(GMT-05:00) Eastern Time",
  },
  {
    id: "America/Panama",
    name: "(GMT-05:00) Panama",
  },
  {
    id: "America/Port-au-Prince",
    name: "(GMT-05:00) Port-au-Prince",
  },
  {
    id: "America/Rio_Branco",
    name: "(GMT-05:00) Rio Branco",
  },
  {
    id: "America/Toronto",
    name: "(GMT-05:00) Eastern Time - Toronto",
  },
  {
    id: "Pacific/Easter",
    name: "(GMT-05:00) Easter Island",
  },
  {
    id: "America/Caracas",
    name: "(GMT-04:30) Caracas",
  },
  {
    id: "America/Asuncion",
    name: "(GMT-03:00) Asuncion",
  },
  {
    id: "America/Barbados",
    name: "(GMT-04:00) Barbados",
  },
  {
    id: "America/Boa_Vista",
    name: "(GMT-04:00) Boa Vista",
  },
  {
    id: "America/Campo_Grande",
    name: "(GMT-03:00) Campo Grande",
  },
  {
    id: "America/Cuiaba",
    name: "(GMT-03:00) Cuiaba",
  },
  {
    id: "America/Curacao",
    name: "(GMT-04:00) Curacao",
  },
  {
    id: "America/Grand_Turk",
    name: "(GMT-04:00) Grand Turk",
  },
  {
    id: "America/Guyana",
    name: "(GMT-04:00) Guyana",
  },
  {
    id: "America/Halifax",
    name: "(GMT-04:00) Atlantic Time - Halifax",
  },
  {
    id: "America/La_Paz",
    name: "(GMT-04:00) La Paz",
  },
  {
    id: "America/Manaus",
    name: "(GMT-04:00) Manaus",
  },
  {
    id: "America/Martinique",
    name: "(GMT-04:00) Martinique",
  },
  {
    id: "America/Port_of_Spain",
    name: "(GMT-04:00) Port of Spain",
  },
  {
    id: "America/Porto_Velho",
    name: "(GMT-04:00) Porto Velho",
  },
  {
    id: "America/Puerto_Rico",
    name: "(GMT-04:00) Puerto Rico",
  },
  {
    id: "America/Santo_Domingo",
    name: "(GMT-04:00) Santo Domingo",
  },
  {
    id: "America/Thule",
    name: "(GMT-04:00) Thule",
  },
  {
    id: "Atlantic/Bermuda",
    name: "(GMT-04:00) Bermuda",
  },
  {
    id: "America/St_Johns",
    name: "(GMT-03:30) Newfoundland Time - St. Johns",
  },
  {
    id: "America/Araguaina",
    name: "(GMT-03:00) Araguaina",
  },
  {
    id: "America/Argentina/Buenos_Aires",
    name: "(GMT-03:00) Buenos Aires",
  },
  {
    id: "America/Bahia",
    name: "(GMT-03:00) Salvador",
  },
  {
    id: "America/Belem",
    name: "(GMT-03:00) Belem",
  },
  {
    id: "America/Cayenne",
    name: "(GMT-03:00) Cayenne",
  },
  {
    id: "America/Fortaleza",
    name: "(GMT-03:00) Fortaleza",
  },
  {
    id: "America/Godthab",
    name: "(GMT-03:00) Godthab",
  },
  {
    id: "America/Maceio",
    name: "(GMT-03:00) Maceio",
  },
  {
    id: "America/Miquelon",
    name: "(GMT-03:00) Miquelon",
  },
  {
    id: "America/Montevideo",
    name: "(GMT-03:00) Montevideo",
  },
  {
    id: "America/Paramaribo",
    name: "(GMT-03:00) Paramaribo",
  },
  {
    id: "America/Recife",
    name: "(GMT-03:00) Recife",
  },
  {
    id: "America/Santiago",
    name: "(GMT-03:00) Santiago",
  },
  {
    id: "America/Sao_Paulo",
    name: "(GMT-02:00) Sao Paulo",
  },
  {
    id: "Antarctica/Palmer",
    name: "(GMT-03:00) Palmer",
  },
  {
    id: "Antarctica/Rothera",
    name: "(GMT-03:00) Rothera",
  },
  {
    id: "Atlantic/Stanley",
    name: "(GMT-03:00) Stanley",
  },
  {
    id: "America/Noronha",
    name: "(GMT-02:00) Noronha",
  },
  {
    id: "Atlantic/South_Georgia",
    name: "(GMT-02:00) South Georgia",
  },
  {
    id: "America/Scoresbysund",
    name: "(GMT-01:00) Scoresbysund",
  },
  {
    id: "Atlantic/Azores",
    name: "(GMT-01:00) Azores",
  },
  {
    id: "Atlantic/Cape_Verde",
    name: "(GMT-01:00) Cape Verde",
  },
  {
    id: "Africa/Abidjan",
    name: "(GMT+00:00) Abidjan",
  },
  {
    id: "Africa/Accra",
    name: "(GMT+00:00) Accra",
  },
  {
    id: "Africa/Bissau",
    name: "(GMT+00:00) Bissau",
  },
  {
    id: "Africa/Casablanca",
    name: "(GMT+00:00) Casablanca",
  },
  {
    id: "Africa/El_Aaiun",
    name: "(GMT+00:00) El Aaiun",
  },
  {
    id: "Africa/Monrovia",
    name: "(GMT+00:00) Monrovia",
  },
  {
    id: "America/Danmarkshavn",
    name: "(GMT+00:00) Danmarkshavn",
  },
  {
    id: "Atlantic/Canary",
    name: "(GMT+00:00) Canary Islands",
  },
  {
    id: "Atlantic/Faroe",
    name: "(GMT+00:00) Faeroe",
  },
  {
    id: "Atlantic/Reykjavik",
    name: "(GMT+00:00) Reykjavik",
  },
  {
    id: "Etc/GMT",
    name: "(GMT+00:00) GMT (no daylight saving)",
  },
  {
    id: "Europe/Dublin",
    name: "(GMT+00:00) Dublin",
  },
  {
    id: "Europe/Lisbon",
    name: "(GMT+00:00) Lisbon",
  },
  {
    id: "Europe/London",
    name: "(GMT+00:00) London",
  },
  {
    id: "Africa/Algiers",
    name: "(GMT+01:00) Algiers",
  },
  {
    id: "Africa/Ceuta",
    name: "(GMT+01:00) Ceuta",
  },
  {
    id: "Africa/Lagos",
    name: "(GMT+01:00) Lagos",
  },
  {
    id: "Africa/Ndjamena",
    name: "(GMT+01:00) Ndjamena",
  },
  {
    id: "Africa/Tunis",
    name: "(GMT+01:00) Tunis",
  },
  {
    id: "Africa/Windhoek",
    name: "(GMT+02:00) Windhoek",
  },
  {
    id: "Europe/Amsterdam",
    name: "(GMT+01:00) Amsterdam",
  },
  {
    id: "Europe/Andorra",
    name: "(GMT+01:00) Andorra",
  },
  {
    id: "Europe/Belgrade",
    name: "(GMT+01:00) Central European Time - Belgrade",
  },
  {
    id: "Europe/Berlin",
    name: "(GMT+01:00) Berlin",
  },
  {
    id: "Europe/Brussels",
    name: "(GMT+01:00) Brussels",
  },
  {
    id: "Europe/Budapest",
    name: "(GMT+01:00) Budapest",
  },
  {
    id: "Europe/Copenhagen",
    name: "(GMT+01:00) Copenhagen",
  },
  {
    id: "Europe/Gibraltar",
    name: "(GMT+01:00) Gibraltar",
  },
  {
    id: "Europe/Luxembourg",
    name: "(GMT+01:00) Luxembourg",
  },
  {
    id: "Europe/Madrid",
    name: "(GMT+01:00) Madrid",
  },
  {
    id: "Europe/Malta",
    name: "(GMT+01:00) Malta",
  },
  {
    id: "Europe/Monaco",
    name: "(GMT+01:00) Monaco",
  },
  {
    id: "Europe/Oslo",
    name: "(GMT+01:00) Oslo",
  },
  {
    id: "Europe/Paris",
    name: "(GMT+01:00) Paris",
  },
  {
    id: "Europe/Prague",
    name: "(GMT+01:00) Central European Time - Prague",
  },
  {
    id: "Europe/Rome",
    name: "(GMT+01:00) Rome",
  },
  {
    id: "Europe/Stockholm",
    name: "(GMT+01:00) Stockholm",
  },
  {
    id: "Europe/Tirane",
    name: "(GMT+01:00) Tirane",
  },
  {
    id: "Europe/Vienna",
    name: "(GMT+01:00) Vienna",
  },
  {
    id: "Europe/Warsaw",
    name: "(GMT+01:00) Warsaw",
  },
  {
    id: "Europe/Zurich",
    name: "(GMT+01:00) Zurich",
  },
  {
    id: "Africa/Cairo",
    name: "(GMT+02:00) Cairo",
  },
  {
    id: "Africa/Johannesburg",
    name: "(GMT+02:00) Johannesburg",
  },
  {
    id: "Africa/Maputo",
    name: "(GMT+02:00) Maputo",
  },
  {
    id: "Africa/Tripoli",
    name: "(GMT+02:00) Tripoli",
  },
  {
    id: "Asia/Amman",
    name: "(GMT+02:00) Amman",
  },
  {
    id: "Asia/Beirut",
    name: "(GMT+02:00) Beirut",
  },
  {
    id: "Asia/Damascus",
    name: "(GMT+02:00) Damascus",
  },
  {
    id: "Asia/Gaza",
    name: "(GMT+02:00) Gaza",
  },
  {
    id: "Asia/Jerusalem",
    name: "(GMT+02:00) Jerusalem",
  },
  {
    id: "Asia/Nicosia",
    name: "(GMT+02:00) Nicosia",
  },
  {
    id: "Europe/Athens",
    name: "(GMT+02:00) Athens",
  },
  {
    id: "Europe/Bucharest",
    name: "(GMT+02:00) Bucharest",
  },
  {
    id: "Europe/Chisinau",
    name: "(GMT+02:00) Chisinau",
  },
  {
    id: "Europe/Helsinki",
    name: "(GMT+02:00) Helsinki",
  },
  {
    id: "Europe/Istanbul",
    name: "(GMT+02:00) Istanbul",
  },
  {
    id: "Europe/Kaliningrad",
    name: "(GMT+02:00) Moscow-01 - Kaliningrad",
  },
  {
    id: "Europe/Kiev",
    name: "(GMT+02:00) Kiev",
  },
  {
    id: "Europe/Riga",
    name: "(GMT+02:00) Riga",
  },
  {
    id: "Europe/Sofia",
    name: "(GMT+02:00) Sofia",
  },
  {
    id: "Europe/Tallinn",
    name: "(GMT+02:00) Tallinn",
  },
  {
    id: "Europe/Vilnius",
    name: "(GMT+02:00) Vilnius",
  },
  {
    id: "Africa/Khartoum",
    name: "(GMT+03:00) Khartoum",
  },
  {
    id: "Africa/Nairobi",
    name: "(GMT+03:00) Nairobi",
  },
  {
    id: "Antarctica/Syowa",
    name: "(GMT+03:00) Syowa",
  },
  {
    id: "Asia/Baghdad",
    name: "(GMT+03:00) Baghdad",
  },
  {
    id: "Asia/Qatar",
    name: "(GMT+03:00) Qatar",
  },
  {
    id: "Asia/Riyadh",
    name: "(GMT+03:00) Riyadh",
  },
  {
    id: "Europe/Minsk",
    name: "(GMT+03:00) Minsk",
  },
  {
    id: "Europe/Moscow",
    name: "(GMT+03:00) Moscow+00 - Moscow",
  },
  {
    id: "Asia/Tehran",
    name: "(GMT+03:30) Tehran",
  },
  {
    id: "Asia/Baku",
    name: "(GMT+04:00) Baku",
  },
  {
    id: "Asia/Dubai",
    name: "(GMT+04:00) Dubai",
  },
  {
    id: "Asia/Tbilisi",
    name: "(GMT+04:00) Tbilisi",
  },
  {
    id: "Asia/Yerevan",
    name: "(GMT+04:00) Yerevan",
  },
  {
    id: "Europe/Samara",
    name: "(GMT+04:00) Moscow+01 - Samara",
  },
  {
    id: "Indian/Mahe",
    name: "(GMT+04:00) Mahe",
  },
  {
    id: "Indian/Mauritius",
    name: "(GMT+04:00) Mauritius",
  },
  {
    id: "Indian/Reunion",
    name: "(GMT+04:00) Reunion",
  },
  {
    id: "Asia/Kabul",
    name: "(GMT+04:30) Kabul",
  },
  {
    id: "Antarctica/Mawson",
    name: "(GMT+05:00) Mawson",
  },
  {
    id: "Asia/Aqtau",
    name: "(GMT+05:00) Aqtau",
  },
  {
    id: "Asia/Aqtobe",
    name: "(GMT+05:00) Aqtobe",
  },
  {
    id: "Asia/Ashgabat",
    name: "(GMT+05:00) Ashgabat",
  },
  {
    id: "Asia/Dushanbe",
    name: "(GMT+05:00) Dushanbe",
  },
  {
    id: "Asia/Karachi",
    name: "(GMT+05:00) Karachi",
  },
  {
    id: "Asia/Tashkent",
    name: "(GMT+05:00) Tashkent",
  },
  {
    id: "Asia/Yekaterinburg",
    name: "(GMT+05:00) Moscow+02 - Yekaterinburg",
  },
  {
    id: "Indian/Kerguelen",
    name: "(GMT+05:00) Kerguelen",
  },
  {
    id: "Indian/Maldives",
    name: "(GMT+05:00) Maldives",
  },
  {
    id: "Asia/Kolkata",
    name: "(GMT+05:30) India Standard Time",
  },
  {
    id: "Asia/Colombo",
    name: "(GMT+05:30) Colombo",
  },
  {
    id: "Asia/Katmandu",
    name: "(GMT+05:45) Katmandu",
  },
  {
    id: "Antarctica/Vostok",
    name: "(GMT+06:00) Vostok",
  },
  {
    id: "Asia/Almaty",
    name: "(GMT+06:00) Almaty",
  },
  {
    id: "Asia/Bishkek",
    name: "(GMT+06:00) Bishkek",
  },
  {
    id: "Asia/Dhaka",
    name: "(GMT+06:00) Dhaka",
  },
  {
    id: "Asia/Omsk",
    name: "(GMT+06:00) Moscow+03 - Omsk, Novosibirsk",
  },
  {
    id: "Asia/Thimphu",
    name: "(GMT+06:00) Thimphu",
  },
  {
    id: "Indian/Chagos",
    name: "(GMT+06:00) Chagos",
  },
  {
    id: "Asia/Rangoon",
    name: "(GMT+06:30) Rangoon",
  },
  {
    id: "Indian/Cocos",
    name: "(GMT+06:30) Cocos",
  },
  {
    id: "Antarctica/Davis",
    name: "(GMT+07:00) Davis",
  },
  {
    id: "Asia/Bangkok",
    name: "(GMT+07:00) Bangkok",
  },
  {
    id: "Asia/Hovd",
    name: "(GMT+07:00) Hovd",
  },
  {
    id: "Asia/Jakarta",
    name: "(GMT+07:00) Jakarta",
  },
  {
    id: "Asia/Krasnoyarsk",
    name: "(GMT+07:00) Moscow+04 - Krasnoyarsk",
  },
  {
    id: "Asia/Saigon",
    name: "(GMT+07:00) Hanoi",
  },
  {
    id: "Indian/Christmas",
    name: "(GMT+07:00) Christmas",
  },
  {
    id: "Antarctica/Casey",
    name: "(GMT+08:00) Casey",
  },
  {
    id: "Asia/Brunei",
    name: "(GMT+08:00) Brunei",
  },
  {
    id: "Asia/Choibalsan",
    name: "(GMT+08:00) Choibalsan",
  },
  {
    id: "Asia/Hong_Kong",
    name: "(GMT+08:00) Hong Kong",
  },
  {
    id: "Asia/Irkutsk",
    name: "(GMT+08:00) Moscow+05 - Irkutsk",
  },
  {
    id: "Asia/Kuala_Lumpur",
    name: "(GMT+08:00) Kuala Lumpur",
  },
  {
    id: "Asia/Macau",
    name: "(GMT+08:00) Macau",
  },
  {
    id: "Asia/Makassar",
    name: "(GMT+08:00) Makassar",
  },
  {
    id: "Asia/Manila",
    name: "(GMT+08:00) Manila",
  },
  {
    id: "Asia/Shanghai",
    name: "(GMT+08:00) China Time - Beijing",
  },
  {
    id: "Asia/Singapore",
    name: "(GMT+08:00) Singapore",
  },
  {
    id: "Asia/Taipei",
    name: "(GMT+08:00) Taipei",
  },
  {
    id: "Asia/Ulaanbaatar",
    name: "(GMT+08:00) Ulaanbaatar",
  },
  {
    id: "Australia/Perth",
    name: "(GMT+08:00) Western Time - Perth",
  },
  {
    id: "Asia/Pyongyang",
    name: "(GMT+08:30) Pyongyang",
  },
  {
    id: "Asia/Dili",
    name: "(GMT+09:00) Dili",
  },
  {
    id: "Asia/Jayapura",
    name: "(GMT+09:00) Jayapura",
  },
  {
    id: "Asia/Seoul",
    name: "(GMT+09:00) Seoul",
  },
  {
    id: "Asia/Tokyo",
    name: "(GMT+09:00) Tokyo",
  },
  {
    id: "Asia/Yakutsk",
    name: "(GMT+09:00) Moscow+06 - Yakutsk",
  },
  {
    id: "Pacific/Palau",
    name: "(GMT+09:00) Palau",
  },
  {
    id: "Australia/Adelaide",
    name: "(GMT+10:30) Central Time - Adelaide",
  },
  {
    id: "Australia/Darwin",
    name: "(GMT+09:30) Central Time - Darwin",
  },
  {
    id: "Antarctica/DumontDUrville",
    name: "(GMT+10:00) Dumont D'Urville",
  },
  {
    id: "Asia/Magadan",
    name: "(GMT+10:00) Moscow+07 - Magadan",
  },
  {
    id: "Asia/Vladivostok",
    name: "(GMT+10:00) Moscow+07 - Yuzhno-Sakhalinsk",
  },
  {
    id: "Australia/Brisbane",
    name: "(GMT+10:00) Eastern Time - Brisbane",
  },
  {
    id: "Australia/Hobart",
    name: "(GMT+11:00) Eastern Time - Hobart",
  },
  {
    id: "Australia/Sydney",
    name: "(GMT+11:00) Eastern Time - Melbourne, Sydney",
  },
  {
    id: "Pacific/Chuuk",
    name: "(GMT+10:00) Truk",
  },
  {
    id: "Pacific/Guam",
    name: "(GMT+10:00) Guam",
  },
  {
    id: "Pacific/Port_Moresby",
    name: "(GMT+10:00) Port Moresby",
  },
  {
    id: "Pacific/Efate",
    name: "(GMT+11:00) Efate",
  },
  {
    id: "Pacific/Guadalcanal",
    name: "(GMT+11:00) Guadalcanal",
  },
  {
    id: "Pacific/Kosrae",
    name: "(GMT+11:00) Kosrae",
  },
  {
    id: "Pacific/Norfolk",
    name: "(GMT+11:00) Norfolk",
  },
  {
    id: "Pacific/Noumea",
    name: "(GMT+11:00) Noumea",
  },
  {
    id: "Pacific/Pohnpei",
    name: "(GMT+11:00) Ponape",
  },
  {
    id: "Asia/Kamchatka",
    name: "(GMT+12:00) Moscow+09 - Petropavlovsk-Kamchatskiy",
  },
  {
    id: "Pacific/Auckland",
    name: "(GMT+13:00) Auckland",
  },
  {
    id: "Pacific/Fiji",
    name: "(GMT+13:00) Fiji",
  },
  {
    id: "Pacific/Funafuti",
    name: "(GMT+12:00) Funafuti",
  },
  {
    id: "Pacific/Kwajalein",
    name: "(GMT+12:00) Kwajalein",
  },
  {
    id: "Pacific/Majuro",
    name: "(GMT+12:00) Majuro",
  },
  {
    id: "Pacific/Nauru",
    name: "(GMT+12:00) Nauru",
  },
  {
    id: "Pacific/Tarawa",
    name: "(GMT+12:00) Tarawa",
  },
  {
    id: "Pacific/Wake",
    name: "(GMT+12:00) Wake",
  },
  {
    id: "Pacific/Wallis",
    name: "(GMT+12:00) Wallis",
  },
  {
    id: "Pacific/Apia",
    name: "(GMT+14:00) Apia",
  },
  {
    id: "Pacific/Enderbury",
    name: "(GMT+13:00) Enderbury",
  },
  {
    id: "Pacific/Fakaofo",
    name: "(GMT+13:00) Fakaofo",
  },
  {
    id: "Pacific/Tongatapu",
    name: "(GMT+13:00) Tongatapu",
  },
  {
    id: "Pacific/Kiritimati",
    name: "(GMT+14:00) Kiritimati",
  },
  {
    id: "Africa/Addis_Ababa",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Bamako",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Bangui",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Banjul",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Blantyre",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Brazzaville",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Bujumbura",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Asia/Oral",
    name: "(UTC+05:00) Ashgabat, Tashkent",
  },
  {
    id: "Africa/Conakry",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Dakar",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Dar_es_Salaam",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Douala",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Freetown",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Gaborone",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Harare",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Juba",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Kampala",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Kinshasa",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Libreville",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Lome",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Kigali",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Luanda",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Lubumbashi",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Lusaka",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Malabo",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Mbabane",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Mogadishu",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Africa/Maseru",
    name: "(UTC+02:00) Harare, Pretoria",
  },
  {
    id: "Africa/Niamey",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "Africa/Nouakchott",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Ouagadougou",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Africa/Porto-Novo",
    name: "(UTC+01:00) West Central Africa",
  },
  {
    id: "America/Argentina/Salta",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/La_Rioja",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/Rio_Gallegos",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/San_Juan",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/San_Luis",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/Tucuman",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Argentina/Ushuaia",
    name: "(UTC-03:00) Buenos Aires",
  },
  {
    id: "America/Bahia_Banderas",
    name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  },
  {
    id: "America/Blanc-Sablon",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/Boise",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Cambridge_Bay",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Cambridge_Bay",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Chihuahua",
    name: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  },
  {
    id: "America/Coral_Harbour",
    name: "(UTC-05:00) Bogota, Lima, Quito",
  },
  {
    id: "America/Creston",
    name: "(UTC-07:00) Arizona",
  },
  {
    id: "America/Detroit",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Detroit",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Dominica",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/Eirunepe",
    name: "(UTC-05:00) Bogota, Lima, Quito",
  },
  {
    id: "America/Glace_Bay",
    name: "(UTC-04:00) Atlantic Time (Canada)",
  },
  {
    id: "America/Goose_Bay",
    name: "(UTC-04:00) Atlantic Time (Canada)",
  },
  {
    id: "America/Indiana/Knox",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Indiana/Vincennes",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Indiana/Winamac",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Inuvik",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Juneau",
    name: "(UTC-09:00) Alaska",
  },
  {
    id: "America/Kentucky/Monticello",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Kralendijk",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/Matamoros",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Menominee",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Merida",
    name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  },
  {
    id: "America/Moncton",
    name: "(UTC-04:00) Atlantic Time (Canada)",
  },
  {
    id: "America/Monterrey",
    name: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  },
  {
    id: "America/Montreal",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Nome",
    name: "(UTC-09:00) Alaska",
  },
  {
    id: "America/North_Dakota/Beulah",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/North_Dakota/Center",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/North_Dakota/New_Salem",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Ojinaga",
    name: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    id: "America/Pangnirtung",
    name: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  {
    id: "America/Rankin_Inlet",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Rankin_Inlet",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Resolute",
    name: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    id: "America/Santa_Isabel",
    name: "(UTC-08:00) Baja California",
  },
  {
    id: "America/Santarem",
    name: "(UTC-03:00) Cayenne, Fortaleza",
  },
  {
    id: "America/Sitka",
    name: "(UTC-09:00) Alaska",
  },
  {
    id: "America/St_Lucia",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "America/St_Vincent",
    name: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  {
    id: "Arctic/Longyearbyen",
    name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    id: "Asia/Aden",
    name: "(UTC+03:00) Kuwait, Riyadh",
  },
  {
    id: "Asia/Anadyr",
    name: "(UTC+12:00) Magadan",
  },
  {
    id: "Asia/Kathmandu",
    name: "(UTC+05:45) Kathmandu",
  },
  {
    id: "Asia/Kuching",
    name: "(UTC+08:00) Kuala Lumpur, Singapore",
  },
  {
    id: "Asia/Muscat",
    name: "(UTC+04:00) Abu Dhabi, Muscat",
  },
  {
    id: "Asia/Novokuznetsk",
    name: "(UTC+07:00) Novosibirsk",
  },
  {
    id: "Asia/Novosibirsk",
    name: "(UTC+07:00) Novosibirsk",
  },
  {
    id: "Asia/Phnom_Penh",
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  },
  {
    id: "Asia/Pontianak",
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  },
  {
    id: "Asia/Qyzylorda",
    name: "(UTC+06:00) Nur-Sultan (Astana)",
  },
  {
    id: "Asia/Sakhalin",
    name: "(UTC+11:00) Vladivostok",
  },
  {
    id: "Asia/Samarkand",
    name: "(UTC+05:00) Ashgabat, Tashkent",
  },
  {
    id: "Asia/Urumqi",
    name: "(UTC+06:00) Nur-Sultan (Astana)",
  },
  {
    id: "Asia/Vientiane",
    name: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  },
  {
    id: "Atlantic/Madeira",
    name: "(UTC) Dublin, Lisbon",
  },
  {
    id: "Atlantic/St_Helena",
    name: "(UTC) Monrovia, Reykjavik",
  },
  {
    id: "Australia/Broken_Hill",
    name: "(UTC+09:30) Adelaide",
  },
  {
    id: "Australia/Melbourne",
    name: "(UTC+10:00) Canberra, Melbourne, Sydney",
  },
  {
    id: "Europe/Bratislava",
    name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    id: "Europe/Isle_of_Man",
    name: "(UTC) Edinburgh, London",
  },
  {
    id: "Europe/Isle_of_Man",
    name: "(UTC+01:00) Edinburgh, London",
  },
  {
    id: "Europe/Ljubljana",
    name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    id: "Europe/Podgorica",
    name: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    id: "Europe/Sarajevo",
    name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    id: "Europe/Simferopol",
    name: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
  },
  {
    id: "Europe/Skopje",
    name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    id: "Europe/Uzhgorod",
    name: "(UTC+02:00) E. Europe",
  },
  {
    id: "Europe/Uzhgorod",
    name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  {
    id: "Europe/Vaduz",
    name: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    id: "Europe/Volgograd",
    name: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
  },
  {
    id: "Europe/Zagreb",
    name: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    id: "Europe/Zaporozhye",
    name: "(UTC+02:00) E. Europe",
  },
  {
    id: "Europe/Zaporozhye",
    name: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  {
    id: "Indian/Antananarivo",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Indian/Comoro",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Indian/Mayotte",
    name: "(UTC+03:00) Nairobi",
  },
  {
    id: "Pacific/Johnston",
    name: "(UTC-10:00) Hawaii",
  },
  {
    id: "Pacific/Midway",
    name: "(UTC-11:00) Coordinated Universal Time-11",
  },
  {
    id: "Pacific/Saipan",
    name: "(UTC+10:00) Guam, Port Moresby",
  },
];

export const dialPadChanges = (iscall: boolean, userAgent: any, isAttended: any, isCallHold: any, isCallMute: any, isCallEnded: any, isTransfer: any) => {
  //   store.dispatch({
  //     type: Types.DIAL_PAD_CHANGES,
  //     payload: {
  //       isCallAccepted: iscall,
  //       dialedUserAgent: userAgent,
  //       isAttended: isAttended,
  //       isCallHold: isCallHold,
  //       isCallMute: isCallMute,
  //       isCallEnded: isCallEnded,
  //       isTransfer: isTransfer
  //     }
  //   });
};

export const storeUserAgent = (UA: any, sucess: any) => {
  //   store.dispatch({
  //     type: Types.USER_AGENT_REDUCER,
  //     payload: {
  //       userAgent: UA,
  //       isSuccess: sucess,
  //     }
  //   });
};

export const getToken = () => {
  return document.cookie
    .split(";")
    .map((cookie) => cookie.split("="))
    .reduce(
      (accumulator, [key, value]) => ({
        ...accumulator,
        [key.trim()]: decodeURIComponent(value),
      }),
      {}
    );
};

export function encryptCodes(content: any, passcode: any) {
  var result: any = [];
  var passLen = passcode.length;

  for (var i = 0; i < content.length; i++) {
    var passOffset = i % passLen;

    var calAscii = content.charCodeAt(i) + passcode.charCodeAt(passOffset);

    result.push(calAscii);
  }

  return JSON.stringify(result);
}

export function decryptCodes(content: any, passcode: any) {
  let result: any = [];
  var str = "";

  var codesArr = JSON.parse(content);
  var passLen = passcode.length;

  for (var i = 0; i < codesArr.length; i++) {
    var passOffset = i % passLen;

    let calAscii: any = codesArr[i] - passcode.charCodeAt(passOffset);

    result.push(calAscii);
  }

  for (var j = 0; j < result.length; j++) {
    var ch = String.fromCharCode(result[j]);
    str += ch;
  }

  return str;
}

export const SignOut = () => {
  const navigate = useNavigate();
  Cookie.clear();
  navigate("/login");
  ClearStorage();

  // localStorage.clear();
  // sessionStorage.clear();
  //unregister();
};

export const getChannelsList = () => {
  // const token: any = Cookie.get();
  // let LoginUserDetails: any = token["accessToken"] && jwt_decode(token["accessToken"]);
  //   CoreServices.get(`/channel_get`).then((value: any) => {
  //     if (value && value.data.statusCode === 200) {
  //
  //       return value.data.getchannelList[0]
  //     }
  //   })
};
export function groupbyday(data: any) {
  const groups =
    data &&
    data.reduce((groups: any, game: any) => {
      let date: any = get_recent_date(game.sessionStartTime * 1000);

      date = date.split(" ");
      date = date[4];
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(game);
      return groups;
    }, {});

  const groupArrays = Object.keys(groups).map((date) => {
    return {
      date,
      sessionData: groups[date],
    };
  });
  return groupArrays;
}

export function get_recent_date(stamp: any) {
  let day: any = new Date(stamp);
  let min = day.getMinutes().toString().padStart(2, "0");
  let Bdate = day.getHours() + ":" + min;

  let time: any = Bdate.split(" ");
  let ampm: any;

  let [hours, minutes] = time[0].split(":");
  ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  time = hours + ":" + minutes + " " + ampm;

  let month: any = parseInt(day.getMonth()) + 1;
  let date = day.getDate().toString().length > 1 ? day.getDate() : "0" + day.getDate();
  month = month.toString().length > 1 ? month : "0" + month;
  let year = day.getFullYear();
  let newdate = date + "/" + month + "/" + year;

  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

  var curDate = new Date();
  var Cdate = curDate.getDate() + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
  var Ydate = curDate.getDate() - 1 + "-" + (curDate.getMonth() + 1) + "-" + curDate.getFullYear();
  var Tdate = day.getDate() + "-" + (day.getMonth() + 1) + "-" + day.getFullYear();
  var group = Tdate;
  if (Cdate === Tdate) group = "Today";
  else if (Ydate === Tdate) group = "Yesterday";

  return days[day.getDay()] + " " + newdate + " " + time + " " + group;
}

export const startCallTime = (guid: string, dispatch: any) => {
  // let currentCallList: any[] = store.getState().callUserDetails.callDetails || [];
  // let index: number = currentCallList.findIndex((e: any) => e.guid === guid);
  // if (index !== -1) {
  //   let timer: any;
  //   timer = setInterval(() => {
  //     CallTimer(currentCallList, guid);
  //   }, 1000);
  //   currentCallList[index].timer = timer;
  // }
};

export const CallTimer = (currentCallList: any[], guid: string) => {
  //   let incomingDetails: any = store.getState().callUserDetails || {};
  //   try {
  //     let index: number = currentCallList.findIndex((e: any) => e.guid === guid);
  //     let ltime: string = currentCallList[index].callduration || '';
  //     ltime = ltime ? ltime : "00:00:00";
  //     let ss: any = ltime.split(":");
  //     let dt = new Date();
  //     dt.setHours(ss[0]);
  //     dt.setMinutes(ss[1]);
  //     dt.setSeconds(ss[2]);
  //     let dt2 = new Date(dt.valueOf() + 1000);
  //     let temp = dt2.toTimeString().split(" ");
  //     let ts = temp[0].split(":");
  //     let timer: any;
  //     timer = ts[0] + ":" + ts[1] + ":" + ts[2];
  //     currentCallList[index].callduration = timer;
  //     incomingDetails.incomingCallDetail.callduration = timer;
  //     store.dispatch({
  //       type: Types.CONFERENCE_USER_LIST,
  //       payload: {
  //         callDetails: currentCallList
  //       }
  //     });
  //     store.dispatch({
  //       type: Types.INCOMING_CALL_POPUP,
  //       payload: {
  //         status: true,
  //         incomingCallDetail: incomingDetails.incomingCallDetail
  //       }
  //     });
  //   } catch (error) {
  //     // logInfo("CallTimer error is",error);
  //   }
};

export const getAllUSerList = async () => {
  //   await CoreServices.get('/get_all_user_list').then((response: any) => {
  //     if (response.data.statusCode === 200) {
  //       store.dispatch({
  //         type: Types.GET_CONTACT_LIST,
  //         payload: {
  //           isgetContact: true,
  //           allContactList: response.data.getAllUserList
  //         }
  //       })
  //     }
  //   })
};

export const getParticularAgentuser = (arrayList: any, ext: any) => {
  return _.filter(arrayList, (item: any) => {
    return item.ext === ext;
  });
};

export const doResetValuesAndEmptyTheReducers = () => {
  //   store.dispatch({
  //     type: Types.SIDE_BAR_OVERLAY_SETTINGS,
  //     payload: {
  //       sideBarOverlaySettings: false
  //     }
  //   });
  //   store.dispatch({
  //     type: Types.SETUP_EDIT,
  //     payload: {
  //       isEdit: false,
  //       editData: {},
  //       editDataName: "",
  //     },
  //   });
  //   store.dispatch({
  //     type: Types.CODE_SNIPPET,
  //     payload: {
  //       codeSnippet: "",
  //     },
  //   });
  //   store.dispatch({
  //     type: Types.CODE_SNIPPET,
  //     payload: {
  //       codeSnippet: ""
  //     },
  //   });
  //   store.dispatch({
  //     type: Types.PERSONALIZATION,
  //     payload: {
  //       font: "Arial (sans-serif)",
  //       position: "flex-start",
  //       roundedCorners: 25,
  //       chatIconShape: 24,
  //       chatHeaderColor: "#5B55FF",
  //       agentMessageColor: "#E3E4E5",
  //       customerMessageColor: "#E2E2FA",
  //       actionMessageColor: "#FA6E8F",
  //       uploadDocs: false,
  //       createContact: false,
  //       chatToVoice: false,
  //       chatToEmail: false,
  //       conversationHistory: false,
  //     },
  //   });
  //   store.dispatch({
  //     type: Types.BASIC_CHAT_SETINGS,
  //     payload: {
  //       title: "",
  //       description: "",
  //       callFlowId: {},
  //       callFlowName: "",
  //       chatIconLogo: "",
  //       domainArr: [],
  //     },
  //   });
  //   store.dispatch({
  //     type: Types.PRIMARY_FORM,
  //     payload: {
  //       primaryForm: [],
  //       prechatForm: false,
  //     },
  //   });
};

let enableArrQueueList: any = [];
let enableArrSkillList: any = [];
let enableArrRoutingList: any = [];
let queueListArr: any = [];
let routingListArr: any = [];
let skillListArr: any = [];

export const sortEnableQueueListArray = () => {
  enableArrQueueList = [];
  // const InitialSetupReducer: InitialSetupState = store.getState().initialSetupReducer;
  //   for (let i = 0; i < InitialSetupReducer.queueList.length; i++) {
  //     if (InitialSetupReducer.queueList[i].status === 1) {
  //       enableArrQueueList.push(InitialSetupReducer.queueList[i])
  //     }
  //   }
  //   store.dispatch({
  //     type: Types.QUEUE_LIST_ENABLE,
  //     payload: {
  //       EnableQueueList: enableArrQueueList
  //     }
  //   });
};
export const sortEnableSkillListArray = () => {
  enableArrSkillList = [];
  //   const InitialSetupReducer: InitialSetupState = store.getState().initialSetupReducer;
  //   for (let i = 0; i < InitialSetupReducer.skillmanagementList.length; i++) {
  //     if (InitialSetupReducer.skillmanagementList[i].status === 1) {
  //       enableArrSkillList.push(InitialSetupReducer.skillmanagementList[i])
  //     }
  //   }
  //   store.dispatch({
  //     type: Types.SKILL_MANAGEMENT_ENABLE,
  //     payload: {
  //       enableSkillmanagementList: enableArrSkillList
  //     }
  //   });
};

export const sortEnableRoutingProfileList = () => {
  //const InitialSetupReducer: InitialSetupState = store.getState().initialSetupReducer;
  //   enableArrRoutingList = []
  //   for (let i = 0; i < InitialSetupReducer.routingListTableData.length; i++) {
  //     if (InitialSetupReducer.routingListTableData[i].status === 1) {
  //       enableArrRoutingList.push(InitialSetupReducer.routingListTableData[i])
  //     }
  //   }
  //   store.dispatch({
  //     type: Types.ROUTING_PROFILE_ENABLE,
  //     payload: {
  //       routingProfileEnableList: enableArrRoutingList
  //     }
  //   });
};

export const routingListOrganiseFunc = (apiData: any) => {
  routingListArr = [];

  for (let data of apiData) {
    routingListArr.push({
      rid: data?.rid,
      routingname: data?.routing_prof_name,
      routingmethod: data?.routingMethod,
      linkedqueues: data?.No_of_linkedqueue,
      noofagent: data?.no_of_agent,
      status: data?.status,
    });
  }
  //   store.dispatch({
  //     type: Types.ROUTING_PROFILE_DATA,
  //     payload: {
  //       routingListTableData: routingListArr,
  //       routingListConstantData: routingListArr
  //     }
  //   })
  sortEnableRoutingProfileList();
};

export const queueListOrganiseFunc = (value: any) => {
  queueListArr = [];
  for (let list of value) {
    queueListArr.push({
      name: list?.name,
      description: list?.description,
      OutboundCallerId: list?.OutboundCallerId,
      outBoundNumber: list.outBoundNumber,
      maxCallHandlingTimeMM: list.maxCallHandlingTimeMM,
      maxCallHandlingTimeSS: list.maxCallHandlingTimeSS,
      callWrapUpTime: list.callWrapUpTime,
      businessHours: list.hours_of_operation,
      outBoundCallStatus: list.outBoundCallStatus,
      audio: list.settingAudio,
      announcement: list.announcement,
      maximumCallers: list.maximumCallers,
      maximumWaitTime: list.maximumWaitTime,
      qid: list.qid,
      status: list.status,
    });
  }
  //   store.dispatch({
  //     type: Types.QUEUE_LIST,
  //     payload: {
  //       queueList: queueListArr
  //     }
  //   });
  sortEnableQueueListArray();
};

export const skillListOrganiseFunc = (skillresultData: any) => {
  skillListArr = [];
  for (let skilldata of skillresultData) {
    skillListArr.push({
      skill_name: skilldata?.skill_name ? skilldata?.skill_name : "-",
      skill_description: skilldata?.skill_description,
      sid: skilldata?.sid,
      no_of_agnt_sk: skilldata?.no_of_agnt_sk,
      status: skilldata?.status,
    });
  }
  //   store.dispatch({
  //     type: Types.SKILL_MANAGEMENT,
  //     payload: {
  //       skillmanagementList: skillListArr,
  //     }
  //   });
  sortEnableSkillListArray();
};

export const getUser = (ext: any) => {
  const userListData: any = store.getState().userList;

  let index: any = userListData.users.findIndex((item: any) => item.ext.toString() === ext);
  if (index > -1) {
    return userListData.users[index];
  } else {
    return null;
  }
};

export const POSTCODE_REGEXES :any= new Map([
  ["UK", /^([A-Z]{1,2}\d{1,2}[A-Z]?)\s?(\d[A-Z]{2})$/i],
  ["GB", /^([A-Z]{1,2}\d{1,2}[A-Z]?)\s?(\d[A-Z]{2})$/i],
  ["JE", /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/],
  ["GG", /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/],
  ["IM", /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/],
  ["US", /^([0-9]{5})(?:-([0-9]{4}))?$/],
  ["CA", /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ ]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/],
  ["IE", /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/],
  ["DE", /^\d{5}$/],
  ["JP", /^\d{3}-\d{4}$/],
  ["FR", /^(F-)?\d{5}$/],
  ["AU", /^(0[289][0-9]{2}|[1-9][0-9]{3})$/],
  ["IT", /^\d{5}$/],
  ["CH", /^\d{4}$/],
  ["AT", /^(?!0)\d{4}$/],
  ["ES", /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/],
  ["NL", /^\d{4}[ ]?[A-Z]{2}$/],
  ["BE", /^\d{4}$/],
  ["DK", /^\d{4}$/],
  ["SE", /^(SE-)?\d{3}[ ]?\d{2}$/],
  ["NO", /^\d{4}$/],
  ["BR", /^\d{5}[\-]?\d{3}$/],
  ["PT", /^\d{4}([\-]\d{3})?$/],
  ["FI", /^(FI-|AX-)?\d{5}$/],
  ["AX", /^22\d{3}$/],
  ["KR", /^\d{5}$/],
  ["CN", /^[1-9]\d{5}$/],
  ["TW", /^\d{3}(\d{2,3})?$/],
  ["SG", /^\d{6}$/],
  ["DZ", /^\d{5}$/],
  ["AD", /^AD\d{3}$/],
  ["AR", /^[A-HJ-NP-Z]\d{4}([A-Z]{3})?$/],
  ["AM", /^(37)?\d{4}$/],
  ["AZ", /^\d{4}$/],
  ["BH", /^((1[0-2]|[2-9])\d{2})?$/],
  ["BD", /^\d{4}$/],
  ["BB", /^(BB\d{5})?$/],
  ["BY", /^\d{6}$/],
  ["BM", /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/],
  ["BA", /^\d{5}$/],
  ["IO", /^BBND 1ZZ$/],
  ["BN", /^[A-Z]{2}[ ]?\d{4}$/],
  ["BG", /^\d{4}$/],
  ["KH", /^\d{5}$/],
  ["CV", /^\d{4}$/],
  ["CL", /^\d{7}$/],
  ["CR", /^(\d{4,5}|\d{3}-\d{4})$/],
  ["HR", /^(HR-)?\d{5}$/],
  ["CY", /^\d{4}$/],
  ["CZ", /^\d{3}[ ]?\d{2}$/],
  ["DO", /^\d{5}$/],
  ["EC", /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/],
  ["EG", /^\d{5}$/],
  ["EE", /^\d{5}$/],
  ["FO", /^\d{3}$/],
  ["GE", /^\d{4}$/],
  ["GR", /^\d{3}[ ]?\d{2}$/],
  ["GL", /^39\d{2}$/],
  ["GT", /^\d{5}$/],
  ["HT", /^\d{4}$/],
  ["HN", /^(?:\d{5})?$/],
  ["HU", /^\d{4}$/],
  ["IS", /^\d{3}$/],
  ["IN", /^[1-9][0-9]{2}\s?[0-9]{3}$/],
  ["ID", /^\d{5}$/],
  ["IL", /^\d{5,7}$/],
  ["JO", /^\d{5}$/],
  ["KZ", /^\d{6}$/],
  ["KE", /^\d{5}$/],
  ["KW", /^\d{5}$/],
  ["KY", /^KY[123]-\d{4}$/],
  ["LA", /^\d{5}$/],
  ["LV", /^(LV-)?\d{4}$/],
  ["LB", /^(\d{4}([ ]?\d{4})?)?$/],
  ["LI", /^(948[5-9])|(949[0-7])$/],
  ["LT", /^(LT-)?\d{5}$/],
  ["LU", /^(L-)?\d{4}$/],
  ["MK", /^\d{4}$/],
  ["MY", /^\d{5}$/],
  ["MV", /^\d{5}$/],
  ["MT", /^[A-Z]{3}[ ]?\d{2,4}$/],
  ["MU", /^((\d|[A-Z])\d{4})?$/],
  ["MX", /^\d{5}$/],
  ["MD", /^\d{4}$/],
  ["MC", /^980\d{2}$/],
  ["MA", /^\d{5}$/],
  ["NP", /^\d{5}$/],
  ["NZ", /^\d{4}$/],
  ["NI", /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/],
  ["NG", /^(\d{6})?$/],
  ["OM", /^(PC )?\d{3}$/],
  ["PA", /^\d{4}$/],
  ["PK", /^\d{5}$/],
  ["PY", /^\d{4}$/],
  ["PH", /^\d{4}$/],
  ["PL", /^\d{2}-\d{3}$/],
  ["PR", /^00[679]\d{2}([ \-]\d{4})?$/],
  ["RO", /^\d{6}$/],
  ["RU", /^\d{6}$/],
  ["SM", /^4789\d$/],
  ["SA", /^\d{5}$/],
  ["SN", /^\d{5}$/],
  ["SK", /^\d{3}[ ]?\d{2}$/],
  ["SI", /^(SI-)?\d{4}$/],
  ["ZA", /^\d{4}$/],
  ["LK", /^\d{5}$/],
  ["TJ", /^\d{6}$/],
  ["TH", /^\d{5}$/],
  ["TN", /^\d{4}$/],
  ["TR", /^\d{5}$/],
  ["TM", /^\d{6}$/],
  ["UA", /^\d{5}$/],
  ["UY", /^\d{5}$/],
  ["UZ", /^\d{6}$/],
  ["VA", /^00120$/],
  ["VE", /^\d{4}$/],
  ["ZM", /^\d{5}$/],
  ["AS", /^96799$/],
  ["CC", /^6799$/],
  ["CK", /^\d{4}$/],
  ["RS", /^\d{5,6}$/],
  ["ME", /^8\d{4}$/],
  ["CS", /^\d{5}$/],
  ["YU", /^\d{5}$/],
  ["CX", /^6798$/],
  ["ET", /^\d{4}$/],
  ["FK", /^FIQQ 1ZZ$/],
  ["NF", /^2899$/],
  ["FM", /^(9694[1-4])([ \-]\d{4})?$/],
  ["GF", /^9[78]3\d{2}$/],
  ["GN", /^\d{3}$/],
  ["GP", /^9[78][01]\d{2}$/],
  ["GS", /^SIQQ 1ZZ$/],
  ["GU", /^969[123]\d([ \-]\d{4})?$/],
  ["GW", /^\d{4}$/],
  ["HM", /^\d{4}$/],
  ["IQ", /^\d{5}$/],
  ["KG", /^\d{6}$/],
  ["LR", /^\d{4}$/],
  ["LS", /^\d{3}$/],
  ["MG", /^\d{3}$/],
  ["MH", /^969[67]\d([ \-]\d{4})?$/],
  ["MN", /^\d{5}$/],
  ["MP", /^9695[012]([ \-]\d{4})?$/],
  ["MQ", /^9[78]2\d{2}$/],
  ["NC", /^988\d{2}$/],
  ["NE", /^\d{4}$/],
  ["VI", /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/],
  ["VN", /^\d{6}$/],
  ["PF", /^987\d{2}$/],
  ["PG", /^\d{3}$/],
  ["PM", /^9[78]5\d{2}$/],
  ["PN", /^PCRN 1ZZ$/],
  ["PW", /^96940$/],
  ["RE", /^9[78]4\d{2}$/],
  ["SH", /^(ASCN|STHL) 1ZZ$/],
  ["SJ", /^\d{4}$/],
  ["SO", /^\d{5}$/],
  ["SZ", /^[HLMS]\d{3}$/],
  ["TC", /^TKCA 1ZZ$/],
  ["WF", /^986\d{2}$/],
  ["XK", /^\d{5}$/],
  ["YT", /^976\d{2}$/],
  ["GI", /^GX11 1AA/],
  ["BT", /^\d{5}/],
  ["AL", /^\d{4}/],
  ["CU", /^\d{5}/],
  ["UM", /^96898/],
  ["AI", /^(?:AI-)?2640/],
  ["AF", /^\d{4}$/],
  ["SD", /^\d{5}/],
  ["VC", /^VC\d{4}/],
  ["TA", /^TDCU 1ZZ/],
  ["NA", /^\d{5}/],
  ["EH", /^\d{5}/],
  ["BL", /^9[78][01]\d{2}/],
  ["TZ", /^\d{4,5}/],
  ["AC", /^ASCN 1ZZ/],
  ["VG", /^VG\d{4}/],
  ["MZ", /^\d{4}/],
  ["MF", /^9[78][01]\d{2}/],
  ["MM", /^\d{5}/],
  ["SV", /^CP [1-3][1-7][0-2]\d/],
  ["IR", /^\d{5}-?\d{5}/],
  ["PE", /^[0-2]\d{4}$/],
  ["INTL", /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/i],
  ["CO", /^(0[58]|1[135789]|2[0357]|4[147]|5[024]|6[368]|7[036]|8[1568]|9[4579])\d{4}$/],
]);

export const postcodeValidator = (postcode :string, country :string) => {
  try {
    console.log("postcodeValidator :::: >>>>", postcode, country, POSTCODE_REGEXES.get(country), POSTCODE_REGEXES.get(country).test(postcode))
    if (!POSTCODE_REGEXES.has(country)) {
      // throw Error(`Invalid country code: ${country}`);
  }
    return POSTCODE_REGEXES.get(country).test(postcode);
  } catch (error) {
    // throw Error(`Invalid country code: ${country}`);
  }
};
